import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  timeUntilRedirect = 8;

  private ivl: NodeJS.Timeout;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.ivl = setInterval(() => {
      --this.timeUntilRedirect;
      if (this.timeUntilRedirect === 0) {
        clearInterval(this.ivl);
        this.router.navigateByUrl('/landing');
      }
    }, 1000);
  }

  navigate() {
    if (this.ivl) {
      clearInterval(this.ivl);
    }
    this.router.navigateByUrl('/landing');
  }
}
